// @flow
import type TraceEventHandler from 'app/packages/trace-logger/TraceEventHandler';
import { DISABLE_TRACING } from 'app/packages/trace-logger/debugFlags';
import type { BinaryAnnotation, Annotation } from 'app/packages/trace-logger/Stopwatch';

export type TraceLoggerServerDataInputs = {|
  annotations: Array<Annotation>,
  binary_annotations: Array<BinaryAnnotation>,
  client_span_id: string,
  trace_id: string,
  server_span_id?: string,
  path: string,
|};

type TraceLoggerServerData = {
  annotations?: Array<Annotation>,
  binary_annotations?: Array<BinaryAnnotation>,
  client_span_id: string,
  trace_id?: string,
  server_span_id?: string,
  path?: string,
};

export default class TraceLogger {
  handlerMap: { [string]: TraceEventHandler };
  serverTraceData: TraceLoggerServerData;

  /**
   * Initializes a trace store that holds and manages traces during the runtime
   * of an application or request cycle.
   */
  constructor() {
    this.handlerMap = {};
    this.serverTraceData = {};
  }

  isDisabled() {
    return __SERVER__ || DISABLE_TRACING || !(window.performance && window.performance.timing);
  }

  addHandler(handler: TraceEventHandler) {
    this.handlerMap[handler.traceName] = handler;
  }

  sendEvent(traceEvent: Object) {
    if (this.isDisabled()) {
      return;
    }

    // Iterate through our registered handlers and send the event through to
    // each one
    Object.keys(this.handlerMap)
      .map((name) => this.handlerMap[name])
      .forEach((handler: TraceEventHandler) => {
        handler.routeEvent(traceEvent);
      });
  }

  setServerTraceData(data: TraceLoggerServerDataInputs) {
    if (!data) {
      return;
    }
    this.serverTraceData = {
      annotations: data.annotations,
      binary_annotations: data.binary_annotations,
      client_span_id: data.client_span_id,
      trace_id: data.trace_id,
      server_span_id: data.server_span_id,
      path: data.path,
    };
  }

  findHandlerByName(handlerName: string) {
    return this.handlerMap[handlerName];
  }
}
